import ClientApi from "../../apis/Clients";
import CustomersApi from "../../apis/Customers";

export default {
  namespaced: true,
  state: {
    clients: [],
    client: null,
    paginated:{}
  },
  mutations: {
    set_clients(state, clients) {
      state.clients = clients;
    },
    set_client(state, data) {
      state.client = data;
    },
    set_paginated (state, data) {
      state.paginated =  data
  }
  },
  actions: {
    async setClients({commit}, data){
      commit('set_clients', {
        data
      })
    },
    async getClients({ commit }, filters = null) {
      return await ClientApi.get_allPaginated(filters)
        .then((response) => {
          commit('set_paginated', {
            ...response.data
          })
          commit("set_clients", response.data.data);
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          console.log(error);
        });
    },
    async store({ dispatch }, client) {
      return await ClientApi.store(client)
        .then((response) => {
          dispatch("getClients");
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "El registro se realizó de forma correcta.",
            },
            { root: true }
          );
          dispatch("sales/select_client", response.data, { root: true });
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: "Ocurrió un error al registrar, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    emptyCompany({ commit }) {
      commit("set_client", null);
    },
    async searchDocument({ commit, dispatch }, document) {
      return await CustomersApi.search_document(document)
        .then((response) => {
          console.log(response)
          commit("set_client", response.data);
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          let message = "No se encontró número de documento";
          if (error.response.data.error_message) {
            message = error.response.data.error_message;
          }
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: message,
            },
            { root: true }
          );
        });
    },
    async update({ dispatch }, client) {
      return await ClientApi.update(client)
        .then((response) => {
          dispatch("getClients");
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "La actualización se realizó de forma correcta",
            },
            { root: true }
          );
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: "Ocurrió un error al actualizar, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    async change_status({ dispatch }, client) {
      let action = client.active ? "inactivación" : "activación";
      return await ClientApi.change_status(client)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "La " + action + " se relizó de forma correcta.",
            },
            { root: true }
          );
          dispatch("getClients");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al realizar la " +
                action +
                ", vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    async delete({ dispatch }, client) {
      return await ClientApi.delete(client)
        .then((response) => {
          dispatch("getClients");
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "La eliminación se realizó de forma correcta.",
            },
            { root: true }
          );
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: "Ocurrió un error al eliminar, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    async upload({ dispatch }, client) {
      return await ClientApi.upload(client)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message:
                "Los reactivos del archivo se registraron de forma correcta.",
            },
            { root: true }
          );
          dispatch("getClients");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          let message =
            "Ocurrió un error al registrar productos del archivo, vuelva a intentarlo.";
          if (error.response.data && error.response.data.message) {
            message = error.response.data.message;
          }
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: message,
            },
            { root: true }
          );
        });
    },
  },
};
